module.exports = __webpack_public_path__ + "img/oborobane.a5e34a67.jpg";